/**
 * Clause-text helper shared by the garage and bilplats families — the only
 * piece of their old kit with no common equivalent (see `common/`).
 */
import { br, list, p, t } from '@hyranai/regta-document-ir';
const BULLET = '• ';
/**
 * A legacy `ClauseBlock` body as real nodes: blank lines separate
 * paragraphs, runs of "• "-prefixed lines become a bullet list (one item per
 * line), other line breaks inside a paragraph are kept. The words are
 * untouched.
 */
export function clauseBody(body) {
    const out = [];
    for (const chunk of body.split(/\n{2,}/)) {
        let lines = [];
        let bullets = [];
        const flushLines = () => {
            if (lines.length)
                out.push(p(lines.flatMap((line, i) => [...(i > 0 ? [br()] : []), ...(line ? [t(line)] : [])])));
            lines = [];
        };
        const flushBullets = () => {
            if (bullets.length)
                out.push(list(bullets));
            bullets = [];
        };
        for (const line of chunk.split('\n')) {
            if (line.startsWith(BULLET)) {
                flushLines();
                bullets.push(line.slice(BULLET.length));
            }
            else {
                flushBullets();
                lines.push(line);
            }
        }
        flushLines();
        flushBullets();
    }
    return out;
}
//# sourceMappingURL=kit.js.map